module.exports = __webpack_public_path__ + "static/media/login_header_xork.2af95a46.jpg";